import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface StoreHoursProps extends BaseTemplateProps {
  retailerName: string
  whlLength: number
  failedWhlLength: number
  requestTimestamp: string
}

export const StoreHoursUpdatePartialFailure: TemplateDefinition<StoreHoursProps> = {
  renderParams: (props: StoreHoursProps) => ({
    messageKey: 'notificationsDomain.templates.storeHoursUpdatePartialFailure',
    values: {
      retailerName: props.retailerName,
      whlLength: props.whlLength,
      failedWhlLength: props.failedWhlLength,
      requestTimestamp: props.requestTimestamp,
    },
  }),
}
